import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { openBriefProject } from '@disco/state-management/actions/ExplorerActions'
import {
  loadBriefProject,
  getBriefProject,
} from '@disco/state-management/reducers/entities/briefProjects'
import { useParams } from 'react-router-dom'

export const BriefProjectExplorerPage = () => {
  const { projectId } = useParams<{ projectId: string }>()
  const dispatch = useDispatch()

  // Check if project already exists in Redux state
  const existingProject = useSelector(state =>
    getBriefProject(state, { briefProjectId: parseInt(projectId) }),
  )

  useEffect(() => {
    if (projectId) {
      const handleProjectLoad = async () => {
        try {
          let project

          // Check if project already exists in Redux state
          if (existingProject) {
            // Use existing project from Redux state (skip API call)
            project = existingProject
          } else {
            // Load the project data from API
            project = await dispatch(
              loadBriefProject(parseInt(projectId)),
            ).unwrap()
          }

          // Open the project with real data (add type property for BriefProjectListApiItem)
          // Use null for pane since we're loading from outside briefs list
          const projectWithType = { ...project, type: 'project' as const }
          dispatch(openBriefProject(null, null, projectWithType))
        } catch (error) {
          console.error('Failed to load brief project:', error)
          // Handle error - maybe show a notification or redirect
        }
      }

      handleProjectLoad()
    }
  }, [projectId, dispatch, projectId])

  return null
}
